import React from 'react'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useNavigate } from 'react-router-dom';

const DashHeader = () => {
    const navigate = useNavigate()
    const handleLogout = () => {
        localStorage.removeItem('token')
        navigate('/signin')
    }
    return (
        <>
            <header className="bg-blue-600 text-white shadow-md">
                <div className=" px-4 mx-auto py-2">
                    <div className="d-flex justify-content-between align-items-center">
                        {/* Left Section */}
                        <div>
                            <h1 className="text-2xl fw-bold">Medicaid Billing Dashboard</h1>
                            <p className="text-blue-100 mt-1">Manage monthly Medicaid billing and payments</p>
                        </div>

                        {/* Right Section */}
                        <div className="d-flex align-items-center gap-4">
                            {/* Alerts */}
                            {/* <div className="position-relative">
                                <button className="btn btn-primary d-flex align-items-center gap-2">
                                    <i className="fas fa-bell"></i>
                                    <span className="d-none d-md-inline">Alerts</span>
                                </button>
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                    3
                                </span>
                            </div> */}

                            {/* Dropdown Menu */}
                            <div className="dropdown">
                                <button
                                    className="btn d-flex align-items-center gap-2 dropdown-toggle bg-blue-400 border-0"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', backgroundColor: '#60a5fa' }}>
                                        <FontAwesomeIcon icon={faUser} className="text-white" />
                                    </div>
                                    <span className="d-none d-md-inline text-white">Admin User</span>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                    <li>
                                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                            Logout
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Logout Confirmation Modal */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content rounded-3 shadow-lg border-0">
                        <div className="modal-header bg-indigo-600 text-white border-0 rounded-top">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Logout</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center fs-5 text-gray-700">
                            Are you sure you want to logout?
                        </div>
                        <div className="modal-footer justify-content-center border-0 pb-4">
                            <button type="button" className="btn btn-outline-secondary rounded-pill px-4 py-2" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button type="button" className="btn btn-indigo rounded-pill px-5 py-2 text-white" data-bs-dismiss="modal" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Custom Styles */}
            <style>{`
                .btn-indigo {
                    background-color: #4f46e5;
                    border: none;
                    transition: background-color 0.3s ease;
                }
                .btn-indigo:hover {
                    background-color: #4338ca;
                }
                .text-gray-700 {
                    color: #4a5568;
                }
            `}</style>
        </>
    )
}

export default DashHeader
